module.exports = __webpack_public_path__ + "static/cake_roses_lettering-4c54278dac979956391b04249e078e13.jpg";